export default {

  async send({ commit, rootState }) {
    try {
      // Delete all caches associated with our app
      const cacheKeys = await window.caches.keys();
      await Promise.all(cacheKeys.map(key => window.caches.delete(key)));

      // Unregister any service workers associated with our app
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map(sw => sw.unregister()));
      }

      // Reload the page to trigger install of new service worker and re-cache
      setTimeout(() => window.location.reload(), 300)
    } catch (e) {
      console.log(e)
    }
  }
}
